<!-- Component to show and hide operation status (succeeded or failed) in a card panel-->
<template>
    <div v-if="msg" class="white-text card-panel" :class="{green:success, red:!success}">
        {{ msg }}
        <span @click="clearMethod" class="right"><i class="material-icons ">close</i></span>
    </div>
</template>
<script>
export default {
  /** *
   * msg is the String message
   * success a Boolean flat to know what color to print (green success, red failure)
   * clearMethod the parent function to clear the form.
   */
  props: ['msg', 'success', 'clearMethod'],
};
</script>
<style scoped>
span {
  cursor: pointer;
}
</style>
